// 1. الـ Imports لازم تكون في البداية (ترتيب إلزامي)
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 2. كود منع الشاشة الحمراء (بدون استخدام متغيرات غير معرفة)
if (process.env.NODE_ENV === 'development') {
  window.addEventListener('error', (e) => {
    // تجاهل أخطاء السكريبتات الخارجية وأخطاء الـ ResizeObserver
    if (e.message === 'Script error.' || e.message.includes('ResizeObserver')) {
      const overlay = document.getElementById('webpack-dev-server-client-overlay');
      if (overlay) overlay.style.display = 'none';
      const shadowOverlay = document.querySelector('shadow-root'); // لبعض إصدارات الـ Overlay
      if (shadowOverlay) shadowOverlay.style.display = 'none';
    }
  });

  window.addEventListener('unhandledrejection', (e) => {
    const overlay = document.getElementById('webpack-dev-server-client-overlay');
    if (overlay) overlay.style.display = 'none';
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();